export function codePointLength(str: string) {
  return Array.from(str).length;
}

export function hasOneCodepoint(str: string) {
  if (str.length === 0) return false;
  const firstCode = str.codePointAt(0) || 0;
  const firstCharLength = firstCode > 0xffff ? 2 : 1; // Surrogate pairs take 2 UTF-16 code units
  return firstCharLength === str.length;
}
